/**
 * A soft-deleted mission profile, as returned by GET /devices/deleted.
 * Holds the stored data used to prefill CreateDevice on "Recreate".
 *
 * @export
 * @class DeletedProfile
 */
export class DeletedProfile {
  //Fields
  accountId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  location: string;
  description: string;
  deviceType: number;
  serialNumber: string;
  ipv4Address: string;
  netMask: string;
  gateway: string;
  altIpv4Address: string;
  altNetMask: string;
  altGateway: string;
  dateDeleted: string;

  constructor(
    accountId: number,
    firstName: string,
    lastName: string,
    email: string,
    location: string,
    description: string,
    deviceType: number,
    serialNumber: string,
    ipv4Address: string,
    netMask: string,
    gateway: string,
    altIpv4Address: string,
    altNetMask: string,
    altGateway: string,
    dateDeleted: string
  ) {
    this.accountId = accountId;
    this.firstName = firstName || "";
    this.lastName = lastName || "";
    this.fullName = `${this.firstName} ${this.lastName}`.trim();
    this.email = email || "";
    this.location = location || "";
    this.description = description || "";
    this.deviceType = deviceType;
    this.serialNumber = serialNumber || "";
    this.ipv4Address = ipv4Address || "";
    this.netMask = netMask || "";
    this.gateway = gateway || "";
    this.altIpv4Address = altIpv4Address || "";
    this.altNetMask = altNetMask || "";
    this.altGateway = altGateway || "";
    this.dateDeleted = dateDeleted || "";
  }
}
